// main.ts — boot. Bring up the GPU, hand the renderer a scene, raise the DOM
// shell over it, and dismiss the loader. If WebGPU is missing, say so kindly.

import { GPUUnsupportedError, Renderer } from "./gfx";
import { Cosmos } from "./scenes/cosmos";
import { Shell } from "./app/shell";

const boot = document.getElementById("boot");

const fail = (message: string): void => {
  if (!boot) return;
  boot.dataset.fatal = "true";
  boot.dataset.done = "false";
  boot.innerHTML = `<span class="boot__mark">✦</span><span class="boot__text">${message}</span>`;
};

const main = async (): Promise<void> => {
  const canvas = document.getElementById("stage") as HTMLCanvasElement | null;
  const ui = document.getElementById("ui");
  if (!canvas || !ui) throw new Error("missing #stage canvas or #ui root");

  const renderer = await Renderer.create(canvas);
  const cosmos = new Cosmos(renderer);
  renderer.setScene(cosmos);
  renderer.start();

  new Shell(ui, cosmos);

  // Let the first frame land before lifting the curtain.
  requestAnimationFrame(() => {
    if (boot) boot.dataset.done = "true";
  });
};

main().catch((err: unknown) => {
  if (err instanceof GPUUnsupportedError) {
    fail(err.message);
  } else {
    console.error(err);
    fail("Something went wrong bringing the world up. Check the console.");
  }
});
